import { commonFilter } from './filter';

export const CompetitorAdComparisonPoint = {
  pageName: 'Competitor Ad Comparison',
  pageId: '25111',
  pagePath: '/marketing/CompetitorAdComparison',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    ...commonFilter,
  },
  card: {},
  table: {},
};
